import { useParams, Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { comics } from '@/mocks/comics';

const readingPages = [
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20in%20black%20and%20white%20style%2C%20dynamic%20action%20panels%20with%20speed%20lines%2C%20manga%20page%20layout%20with%20multiple%20panels%2C%20expressive%20anime%20character%20in%20combat%20pose%2C%20professional%20comic%20art%2C%20dramatic%20shading%20and%20screen%20tones&width=900&height=1280&seq=read-page-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20characters%20having%20intense%20dialogue%2C%20close-up%20facial%20expressions%2C%20emotional%20scene%2C%20clean%20lineart%2C%20screen%20tone%20shading%2C%20professional%20comic%20art%2C%20dramatic%20panel%20layout&width=900&height=1280&seq=read-page-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20wide%20panoramic%20panel%20showing%20fantasy%20landscape%2C%20character%20traveling%20through%20mountains%2C%20detailed%20background%20art%2C%20atmospheric%20shading%2C%20professional%20comic%20illustration&width=900&height=1280&seq=read-page-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20action%20sequence%20with%20multiple%20small%20panels%2C%20sword%20fighting%20scene%2C%20motion%20lines%20and%20impact%20effects%2C%20dynamic%20composition%2C%20clean%20manga%20art%20style&width=900&height=1280&seq=read-page-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20romantic%20scene%20under%20cherry%20blossoms%2C%20two%20characters%20sharing%20a%20tender%20moment%2C%20soft%20shading%2C%20beautiful%20background%2C%20shojo%20manga%20style%2C%20delicate%20lineart&width=900&height=1280&seq=read-page-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20comedy%20scene%20with%20chibi%20style%20characters%2C%20exaggerated%20funny%20expressions%2C%20chaotic%20panel%20layout%2C%20humorous%20manga%20art%2C%20playful%20tone&width=900&height=1280&seq=read-page-06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20dramatic%20full-page%20illustration%20of%20a%20character%20transforming%2C%20energy%20burst%20effects%2C%20powerful%20aura%2C%20epic%20moment%2C%20detailed%20shading%2C%20professional%20manga%20art&width=900&height=1280&seq=read-page-07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20page%20black%20and%20white%2C%20character%20profile%20close-up%20with%20introspective%20expression%2C%20minimal%20background%2C%20delicate%20shading%2C%20emotional%20portrait%2C%20clean%20manga%20art%20style&width=900&height=1280&seq=read-page-08&orientation=portrait',
];

export default function ComicReadPage() {
  const { slug, chapter } = useParams<{ slug: string; chapter: string }>();
  const comic = comics.find((c) => c.slug === slug);
  const chapterNum = parseInt(chapter || '1', 10);

  if (!comic) {
    return (
      <div className="pt-20 md:pt-24 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-300 mb-4">
            <i className="ri-file-unknow-line text-3xl"></i>
          </div>
          <h2 className="text-xl font-heading text-foreground-900 mb-2">漫画未找到</h2>
          <Link to="/" className="inline-flex px-5 py-2 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const currentChapter = comic.chapters.find((ch) => ch.num === chapterNum) || comic.chapters[0];
  const prevChapter = comic.chapters.find((ch) => ch.num === chapterNum - 1);
  const nextChapter = comic.chapters.find((ch) => ch.num === chapterNum + 1);

  return (
    <>
      <main className="pt-16 md:pt-20 min-h-screen">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: comic.title, href: `/comic/${comic.slug}` },
            { label: `第${currentChapter.num}话 ${currentChapter.title}` },
          ]}
        />

        {/* Chapter Navigation Top */}
        <div className="sticky top-14 md:top-16 z-30 bg-background-50 border-b border-background-200/70">
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
            <Link
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i> 返回目录
            </Link>
            <span className="text-sm font-medium text-foreground-900">
              第{currentChapter.num}话：{currentChapter.title}
            </span>
            <div className="flex items-center gap-2">
              {prevChapter ? (
                <Link
                  to={`/comic/${comic.slug}/read/${prevChapter.num}`}
                  className="px-3 py-1.5 text-xs font-medium bg-background-100 hover:bg-primary-50 hover:text-primary-500 rounded-full transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-s-line mr-0.5"></i>上一话
                </Link>
              ) : (
                <span className="px-3 py-1.5 text-xs text-foreground-300 whitespace-nowrap">
                  <i className="ri-arrow-left-s-line mr-0.5"></i>上一话
                </span>
              )}
              {nextChapter ? (
                <Link
                  to={`/comic/${comic.slug}/read/${nextChapter.num}`}
                  className="px-3 py-1.5 text-xs font-medium bg-primary-500 hover:bg-primary-600 text-white rounded-full transition-colors whitespace-nowrap"
                >
                  下一话<i className="ri-arrow-right-s-line ml-0.5"></i>
                </Link>
              ) : (
                <span className="px-3 py-1.5 text-xs text-foreground-300 whitespace-nowrap">
                  下一话<i className="ri-arrow-right-s-line ml-0.5"></i>
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Reading Content */}
        <article className="max-w-4xl mx-auto px-4 md:px-6 py-8" aria-label={`${comic.title} 第${currentChapter.num}话`}>
          <h1 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">
            {comic.title} - 第{currentChapter.num}话：{currentChapter.title}
          </h1>

          <div className="space-y-4">
            {readingPages.map((imgSrc, i) => (
              <div key={i} className="rounded-lg overflow-hidden bg-background-100">
                <img
                  src={imgSrc}
                  alt={`${comic.title} 第${currentChapter.num}话 第${i + 1}页`}
                  className="w-full h-auto"
                />
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-sm text-foreground-400 mb-6">
              — 下拉式阅读模式，向下滑动继续浏览 —
            </p>
          </div>
        </article>

        {/* Chapter Navigation Bottom */}
        <div className="sticky bottom-0 z-30 bg-background-50/95 backdrop-blur-sm border-t border-background-200/70">
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
            <Link
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i> 返回目录
            </Link>
            <div className="flex items-center gap-2">
              {prevChapter ? (
                <Link
                  to={`/comic/${comic.slug}/read/${prevChapter.num}`}
                  className="px-4 py-2 text-sm font-medium bg-background-100 hover:bg-primary-50 hover:text-primary-500 rounded-full transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-s-line mr-1"></i>上一话
                </Link>
              ) : (
                <span className="px-4 py-2 text-sm text-foreground-300 whitespace-nowrap">
                  <i className="ri-arrow-left-s-line mr-1"></i>上一话
                </span>
              )}
              {nextChapter ? (
                <Link
                  to={`/comic/${comic.slug}/read/${nextChapter.num}`}
                  className="px-4 py-2 text-sm font-medium bg-primary-500 hover:bg-primary-600 text-white rounded-full transition-colors whitespace-nowrap"
                >
                  下一话<i className="ri-arrow-right-s-line ml-1"></i>
                </Link>
              ) : (
                <span className="px-4 py-2 text-sm text-foreground-300 whitespace-nowrap">
                  下一话<i className="ri-arrow-right-s-line ml-1"></i>
                </span>
              )}
            </div>
          </div>
        </div>
      </main>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: `${comic.title} - 第${currentChapter.num}话：${currentChapter.title}`,
          author: { '@type': 'Person', name: comic.author },
          datePublished: currentChapter.updatedAt,
          url: `https://mitaoshaonian.com/comic/${comic.slug}/read/${currentChapter.num}`,
          isPartOf: {
            '@type': 'Book',
            name: comic.title,
            url: `https://mitaoshaonian.com/comic/${comic.slug}`,
          },
        })}
      </script>
    </>
  );
}